import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from '../utils';

const LineChartElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Line Chart',
  icon: 'DocumentTextIcon',
  description: 'Adds a line chart based on data from a stat definition',
  properties: [
    'layout',
    {
      label: 'Stat Content Type',
      name: 'type',
      editor: 'dropdown',
      default: '',
      description:
        'Select the content type that has the stat definition you want to use for the chart.',
      options: [],
      function: {
        name: 'getContentTypes',
        params: []
      },

      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Stat Definition Id',
      name: 'statDefinitionId',
      editor: 'textbox',
      description:
        'The ID of a stat definition that contains the data to display in the chart',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Stat Definition Group Identifier',
      name: 'statDefinitionGroupIdentifier',
      editor: 'textbox',
      description:
        'The name of the group from the stat definition to use in the chart. You can use a placeholder in this field if required i.e. ds.name.field, local.fieldname.fieldname , user.field, or a static value',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Stat Definition Default Group Identifier',
      name: 'statDefinitionDefaultGroupIdentifier',
      editor: 'textbox',
      description:
        'A default group identifier, i.e. the first one to load. This is required in case the previous field has a placeholder',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Stat Definition Value Field Name',
      name: 'stateDefinitionValueField',
      editor: 'textbox',
      description:
        'The name of the field within each document within a stat group, that contains the data to use in the chart',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Vertical Axis Legend Key',
      name: 'yAxisLegend',
      editor: 'textbox',
      description: 'The vertical axis legend i.e. Kg',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Horizontal Axis Time Period',
      name: 'xAxisLegend',
      editor: 'textbox',
      description:
        'The time period for the horizontal axis. One of day, week, month, year. This field also accepts placeholders',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Local Store Key',
      name: 'localStoreKey',
      editor: 'textbox',
      description:
        'Whenever the data for the chart is calculated it is put into the store from the calculateTimeAgreegates function (see code)',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'No Chart Data Image',
      name: 'noDataImage',
      editor: 'image',
      mediaLibraryStoreIn: 'custom_folder',
      mediaLibraryPath: 'apps/',
      description: 'An image to display when there is no chart data available',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    'fontFamily',
    'color',
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default LineChartElementFields;
